/**
 * Created by Administrador on 22/07/2019.
 */
/**
 * Created by Administrador on 26/10/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('cargoReportService', cargoReportService);

    cargoReportService.$inject = ['$http', 'CONFIG', 'messageService'];

    function cargoReportService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/cargoReport';
        var service = {
            getEmbarkation: getEmbarkation,
            getEmbarkationPdf: getEmbarkationPdf,
            getDisembarkation: getDisembarkation,
            getDisembarkationPdf: getDisembarkationPdf,
            getTransference: getTransference,
            getReceptionByOffice: getReceptionByOffice,
            getReceptionByCity: getReceptionByCity,
            getReceptionByOfficePdf: getReceptionByOfficePdf,
            getReceptionByCityPdf: getReceptionByCityPdf,
            getCargoStockReport: getCargoStockReport,
            getCargoStockReportPdf: getCargoStockReportPdf,
            getCargoComingStockReport: getCargoComingStockReport,
            getCargoComingStockReportPdf: getCargoComingStockReportPdf,
            getCargoNotDeliveredPdf: getCargoNotDeliveredPdf,
            getCargoNotDelivery: getCargoNotDelivery,
            getCargoPhoneConsignee: getCargoPhoneConsignee,
            getReceptionByRegion: getReceptionByRegion,
            getReceptionByRegionPdf: getReceptionByRegionPdf,
            getLowChargeList: getLowChargeList,
            getAnnulledStock: getAnnulledStock,
            getRefundChargeList: getRefundChargeList,
            getCargoDelivered: getCargoDelivered
        }

        return service;

        function getEmbarkation(branchOfficeId,flightId,departureFlightId){
            return $http.get(urlBase +'/embarkation?branchOfficeId='+branchOfficeId+'&flightId='+flightId
                +'&departureFlightId='+departureFlightId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getEmbarkationPdf(branchOfficeId,flightId,departureFlightId, reducedPrint){
            return $http.get(urlBase +'/embarkation/pdf?branchOfficeId='+branchOfficeId+'&flightId='+flightId
                +'&departureFlightId='+departureFlightId+"&reducedPrint="+reducedPrint,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function getDisembarkation(branchOfficeId,flightId,departureFlightId){
            return $http.get(urlBase +'/disembarkation?branchOfficeId='+branchOfficeId+'&flightId='+flightId
                +'&departureFlightId='+departureFlightId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getDisembarkationPdf(branchOfficeId,flightId,departureFlightId, reducedPrint){
            return $http.get(urlBase +'/disembarkation/pdf?branchOfficeId='+branchOfficeId+'&flightId='+flightId
                +'&departureFlightId='+departureFlightId+"&reducedPrint="+reducedPrint,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function getTransference(branchOfficeOriginId,branchOfficeDestinyId,output,toDate){
            return $http.get(urlBase +'/transference?branchOfficeOriginId='+branchOfficeOriginId
                +'&branchOfficeDestinyId='+branchOfficeDestinyId+'&output='+output+'&toDate='+toDate)
                .then(function(response){
                    return response;
                })
                .catch(function(error){
                    messageService.findAllError('');
                });
        }

        function getReceptionByOffice(branchOfficeId,fromDate,toDate,detailed){
            return $http.get(urlBase +'/receptionByOffice?branchOfficeId='+branchOfficeId
                +'&fromDate='+fromDate+'&toDate='+toDate+'&detailed='+detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(error){
                    messageService.findAllError('');
                });
        }

        function getReceptionByCity(originCityId,destinyCityId,fromDate,toDate,detailed){
            return $http.get(urlBase +'/receptionByCity?originCityId='+originCityId+'&destinyCityId='+destinyCityId
                +'&fromDate='+fromDate+'&toDate='+toDate+'&detailed='+detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(error){
                    messageService.findAllError('');
                });
        }

        function getReceptionByOfficePdf(branchOfficeId,fromDate,toDate,detailed){
            return $http.get(urlBase +'/receptionByOffice/pdf?branchOfficeId='+branchOfficeId
                +'&fromDate='+fromDate+'&toDate='+toDate+'&detailed='+detailed,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function getReceptionByCityPdf(originCityId,destinyCityId,fromDate,toDate,detailed){
            return $http.get(urlBase +'/receptionByCity/pdf?originCityId='+originCityId+'&destinyCityId='+destinyCityId
                +'&fromDate='+fromDate+'&toDate='+toDate+'&detailed='+detailed,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function getCargoStockReport(branchOfficeId,clientType,destinyCityId,detailed, subClassificationId){
            return $http.get(urlBase +'/stock?branchOfficeId='+branchOfficeId+'&clientType='+clientType
                +'&destinyCityId='+destinyCityId+'&detailed='+detailed+ '&subClassificationId=' + subClassificationId )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getCargoStockReportPdf(branchOfficeId,clientType,destinyCityId,detailed,subClassificationId){
            return $http.get(urlBase +'/stock/pdf?branchOfficeId='+branchOfficeId+'&clientType='+clientType
                +'&destinyCityId='+destinyCityId+'&detailed='+detailed+'&subClassificationId='+subClassificationId,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getCargoComingStockReport(destinyBranchOfficeId){
            return $http.get(urlBase +'/comingStock?destinyBranchOfficeId='+destinyBranchOfficeId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getCargoComingStockReportPdf(destinyBranchOfficeId){
            return $http.get(urlBase +'/comingStock/pdf?destinyBranchOfficeId='+destinyBranchOfficeId,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getCargoNotDeliveredPdf(destinyCityId, destinyBranchOfficeId, quantity, type){
            return $http.get(urlBase +'/cargo-not-delivered/pdf?type='+type+'&quantity='+quantity +'&destinyCityId='+destinyCityId+'&destinyBranchOfficeId='+destinyBranchOfficeId,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getCargoNotDelivery(destinyCityId, destinyBranchOfficeId, quantity, type) {
            return $http.get(urlBase +'/cargo-not-delivered?type='+type+'&quantity='+quantity +'&destinyCityId='+destinyCityId+'&destinyBranchOfficeId='+destinyBranchOfficeId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getCargoPhoneConsignee(arrivalDate, originCityId, destinyCityId, delivery, notDelivery) {
            return $http.get(urlBase +'/cargo-phone-consignee?arrivalDate='+arrivalDate+'&originCityId='+originCityId +'&destinyCityId='+destinyCityId+'&delivery='+delivery+'&notDelivery='+notDelivery)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getReceptionByRegion(cityId, fromDate, toDate, detailed) {
            return $http.get(urlBase +'/receptionByRegion?cityId='+cityId+'&fromDate='+fromDate +'&toDate='+toDate+'&detailed='+detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getReceptionByRegionPdf(cityId, fromDate, toDate, detailed) {
            return $http.get(urlBase +'/receptionByRegion/pdf?cityId='+cityId+'&fromDate='+fromDate +'&toDate='+toDate+'&detailed='+detailed, {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getLowChargeList(fromDate, toDate, branchOfficeId ) {
            return $http.get(urlBase +'/low-charge-list?fromDate='+fromDate +'&toDate='+toDate+'&branchOfficeId='+branchOfficeId )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getAnnulledStock(fromDate, toDate, branchOfficeId ) {
            return $http.get(urlBase +'/annulledStock?branchOfficeId='+branchOfficeId +'&fromDate='+fromDate+'&toDate='+toDate )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getRefundChargeList(fromDate, toDate, branchOfficeId ) {
            return $http.get(urlBase +'/refund-charge-list?fromDate='+fromDate +'&toDate='+toDate+'&branchOfficeId='+branchOfficeId )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getCargoDelivered(deliveryDate, cityId, branchOfficeId, isCity ) {
            return $http.get(urlBase +'/cargo-delivery?deliveryDate='+deliveryDate +'&cityId='+cityId+'&branchOfficeId='+branchOfficeId+'&isCity='+isCity )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }
    }
})();
